import type { IntlShape } from 'react-intl'
import type { TripListRowType, TripListStatus, TripListStatusValue } from './tripListTypes'

const EDITABLE_STATUS_OPTIONS: ReadonlyArray<TripListStatusValue> = [
  'IDEA',
  'NOT_BOOKED',
  'BOOKED',
]

const PLANNING_STATUS_OPTIONS: ReadonlyArray<TripListStatusValue> = [
  'IDEA',
  'NOT_BOOKED',
]

const BOOKED_STATUS_OPTIONS: ReadonlyArray<TripListStatusValue> = [
  'BOOKED',
]

const BOOKED_OPTION_ROW_TYPES: ReadonlySet<TripListRowType> = new Set([
  'activity',
  'dining',
])

export function getTripListStatusLabel(intl: IntlShape, value: TripListStatusValue): string {
  if (value === 'BOOKED') {
    return intl.formatMessage({
      id: 'dsjKlUcoW3tb6U9N7vAr',
      defaultMessage: 'Booked',
      description: 'Status label for trip planner list rows that are already booked',
    })
  }

  if (value === 'IDEA') {
    return intl.formatMessage({
      id: 'WttgNcfcl0cPQu_a0XOe',
      defaultMessage: 'Idea',
      description: 'Status label for trip planner list rows that are trip ideas',
    })
  }

  return intl.formatMessage({
    id: 'hKZyU0u0O8nDud2pEQyI',
    defaultMessage: 'Not booked',
    description: 'Status label for trip planner list rows that are not booked yet',
  })
}

function getTripListStatusOptions(
  value: TripListStatusValue,
  rowType: TripListRowType,
  isBooked: boolean,
  isBookable: boolean,
): ReadonlyArray<TripListStatusValue> {
  if (isBooked) return BOOKED_STATUS_OPTIONS

  const options = isBookable || BOOKED_OPTION_ROW_TYPES.has(rowType) ? EDITABLE_STATUS_OPTIONS : PLANNING_STATUS_OPTIONS
  return options.includes(value) ? options : [value, ...options]
}

export function getTripListStatusTone(value: TripListStatusValue): TripListStatus['tone'] {
  if (value === 'IDEA') return 'idea'
  return value === 'BOOKED' ? 'positive' : 'neutral'
}

export function getTripListStatus(
  intl: IntlShape,
  value: TripListStatusValue,
  rowType: TripListRowType,
  isBooked: boolean,
  isBookable: boolean,
  isEditable: boolean,
): TripListStatus {
  return {
    value,
    label: getTripListStatusLabel(intl, value),
    tone: getTripListStatusTone(value),
    isEditable,
    options: getTripListStatusOptions(value, rowType, isBooked, isBookable),
  }
}
